import { useEffect, useState } from "react";
import type { EventOccurrence } from "@shared/types";
import { eventsApi } from "@/api/client";

/** `refreshKey` lets a caller force a re-run (e.g. after an event elsewhere is edited/deleted). */
export function useSearch(query: string, refreshKey: number = 0) {
  const [results, setResults] = useState<EventOccurrence[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!query.trim()) {
      setResults([]);
      return;
    }
    let cancelled = false;
    setLoading(true);
    const timer = setTimeout(() => {
      eventsApi
        .search(query.trim())
        .then((res) => {
          if (!cancelled) setResults(res.events);
        })
        .finally(() => {
          if (!cancelled) setLoading(false);
        });
    }, 250);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [query, refreshKey]);

  return { results, loading };
}
